import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { STORAGE_KEYS } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const { PROJECT_KEY } = STORAGE_KEYS;
const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [activeProjectId, setActiveProjectId] = useState(
    () => localStorage.getItem(PROJECT_KEY) || null
  );
  const [loading, setLoading] = useState(false);

  const fetchProjects = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/projects");
      setProjects(data);
      if (data.length && !data.find((p) => p.id === activeProjectId)) {
        setActiveProjectId(data[0].id);
        localStorage.setItem(PROJECT_KEY, data[0].id);
      }
    } finally {
      setLoading(false);
    }
  }, [user, activeProjectId]);

  useEffect(() => {
    if (user) fetchProjects();
  }, [user, fetchProjects]);

  const selectProject = (id) => {
    setActiveProjectId(id);
    localStorage.setItem(PROJECT_KEY, id);
  };

  const activeProject = projects.find((p) => p.id === activeProjectId) || null;

  return (
    <ProjectContext.Provider
      value={{ projects, activeProject, activeProjectId, selectProject, fetchProjects, loading }}
    >
      {children}
    </ProjectContext.Provider>
  );
}

export const useProjects = () => useContext(ProjectContext);
